export default {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column'
  },
  line: {
    height: '1px',
    width: '100%',
    background: '#333'
  }
}
